(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarBannerHero() {
    document.querySelectorAll('.banner-hero__switcher').forEach(function (switcher) {
      function actualizarVisibilidad() {
        var menuAbierto = document.documentElement.classList.contains('overflow-hidden') ||
          document.body.classList.contains('overflow-hidden') ||
          document.querySelector('details[open] > summary .header__icon--menu') !== null ||
          document.querySelector('.menu-drawer.is-open') !== null ||
          document.querySelector('menu-drawer[open]') !== null ||
          document.querySelector('.header-drawer[aria-expanded="true"]') !== null;

        if (menuAbierto) {
          switcher.classList.add('banner-hero__switcher--oculto');
        } else {
          switcher.classList.remove('banner-hero__switcher--oculto');
        }
      }

      var observer = new MutationObserver(actualizarVisibilidad);

      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });

      var drawer = document.querySelector('menu-drawer') || document.querySelector('.menu-drawer');
      if (drawer) {
        observer.observe(drawer, {
          attributes: true,
          attributeFilter: ['class', 'open', 'aria-expanded']
        });
      }

      var headerDetails = document.querySelectorAll('header details');
      headerDetails.forEach(function (det) {
        observer.observe(det, {
          attributes: true,
          attributeFilter: ['open']
        });
      });

      actualizarVisibilidad();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarBannerHero);
  } else {
    iniciarBannerHero();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beneficios-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarBeneSlide(seccionId) {
    var seccion = document.getElementById('bene-slide-' + seccionId);
    if (!seccion) return;

    var pista = document.getElementById('bene-pista-' + seccionId);
    var diapositivas = pista ? pista.querySelectorAll('.bene-slide__diapositiva') : [];
    var puntos = seccion.querySelectorAll('.bene-slide__punto[data-seccion="' + seccionId + '"]');

    if (diapositivas.length <= 1) return;

    var indiceActual = 0;
    var duracion = parseInt(getComputedStyle(seccion).getPropertyValue('--bene-duracion')) * 1000 || 3000;
    var temporizador = null;

    function irA(idx) {
      diapositivas[indiceActual].classList.remove('bene-slide__diapositiva--activa');
      puntos[indiceActual].classList.remove('bene-slide__punto--activo', 'bene-slide__punto--progreso');
      puntos[indiceActual].setAttribute('aria-selected', 'false');

      indiceActual = (idx + diapositivas.length) % diapositivas.length;

      diapositivas[indiceActual].classList.add('bene-slide__diapositiva--activa');
      puntos[indiceActual].classList.add('bene-slide__punto--activo');
      puntos[indiceActual].setAttribute('aria-selected', 'true');

      void puntos[indiceActual].offsetWidth;
      puntos[indiceActual].classList.add('bene-slide__punto--progreso');
    }

    function siguiente() {
      irA(indiceActual + 1);
    }

    function iniciarTemporizador() {
      clearInterval(temporizador);
      temporizador = setInterval(siguiente, duracion);
    }

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        clearInterval(temporizador);
        irA(parseInt(this.dataset.indice));
        iniciarTemporizador();
      });
    });

    void puntos[0].offsetWidth;
    puntos[0].classList.add('bene-slide__punto--progreso');
    iniciarTemporizador();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearInterval(temporizador);
      } else {
        iniciarTemporizador();
      }
    });
  }

  function arrancar() {
    document.querySelectorAll('.bene-slide').forEach(function (sec) {
      var id = sec.id.replace('bene-slide-', '');
      iniciarBeneSlide(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-colecciones-carrusel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarruseles() {
    document.querySelectorAll('.carr-col__pista').forEach(function (pista) {
      var arrastrando = false;
      var inicioX, scrollInicial;

      pista.addEventListener('mousedown', function (e) {
        arrastrando = true;
        inicioX = e.pageX - pista.offsetLeft;
        scrollInicial = pista.scrollLeft;
        pista.classList.add('carr-col__pista--arrastrando');
      });

      pista.addEventListener('mouseleave', function () {
        arrastrando = false;
        pista.classList.remove('carr-col__pista--arrastrando');
      });

      pista.addEventListener('mouseup', function () {
        arrastrando = false;
        pista.classList.remove('carr-col__pista--arrastrando');
      });

      pista.addEventListener('mousemove', function (e) {
        if (!arrastrando) return;
        e.preventDefault();
        var x = e.pageX - pista.offsetLeft;
        pista.scrollLeft = scrollInicial - (x - inicioX) * 1.5;
      });

      pista.addEventListener('scroll', function () {
        var tarjeta = pista.querySelector('.carr-col__tarjeta');
        if (!tarjeta) return;
        var gap = parseInt(getComputedStyle(pista).gap) || 12;
        var ancho = tarjeta.offsetWidth + gap;
        var idx = Math.round(pista.scrollLeft / ancho);
        var pistaId = pista.id;
        document.querySelectorAll('[data-pista="' + pistaId + '"].carr-col__indicador').forEach(function (p) {
          p.classList.toggle('carr-col__indicador--activo', parseInt(p.dataset.indice) === idx);
        });
      }, { passive: true });
    });

    document.querySelectorAll('.carr-col__flecha').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pista = document.getElementById(this.dataset.pista);
        if (!pista) return;
        var tarjeta = pista.querySelector('.carr-col__tarjeta');
        var gap = parseInt(getComputedStyle(pista).gap) || 12;
        var ancho = tarjeta ? tarjeta.offsetWidth + gap : 300;
        var dir = this.classList.contains('carr-col__flecha--siguiente') ? 1 : -1;
        pista.scrollBy({ left: dir * ancho, behavior: 'smooth' });
      });
    });

    document.querySelectorAll('.carr-col__indicador').forEach(function (punto) {
      punto.addEventListener('click', function () {
        var pista = document.getElementById(this.dataset.pista);
        if (!pista) return;
        var tarjeta = pista.querySelector('.carr-col__tarjeta');
        var gap = parseInt(getComputedStyle(pista).gap) || 12;
        var ancho = tarjeta ? tarjeta.offsetWidth + gap : 300;
        pista.scrollTo({ left: parseInt(this.dataset.indice) * ancho, behavior: 'smooth' });
        var contenedor = this.closest('.carr-col__indicadores');
        if (contenedor) {
          contenedor.querySelectorAll('.carr-col__indicador').forEach(function (p) {
            p.classList.remove('carr-col__indicador--activo');
          });
        }
        this.classList.add('carr-col__indicador--activo');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarCarruseles);
  } else {
    iniciarCarruseles();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-colecciones-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializarTabs() {
    document.querySelectorAll('.colecciones-tabs').forEach(function (seccion) {
      var tabs = seccion.querySelectorAll('.colecciones-tabs__tab');
      var paneles = seccion.querySelectorAll('.colecciones-tabs__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var indice = this.getAttribute('data-tab');

          tabs.forEach(function (t) {
            t.classList.remove('colecciones-tabs__tab--activo');
          });
          paneles.forEach(function (p) {
            p.classList.remove('colecciones-tabs__panel--activo');
          });

          this.classList.add('colecciones-tabs__tab--activo');
          seccion.querySelector('.colecciones-tabs__panel[data-panel="' + indice + '"]').classList.add('colecciones-tabs__panel--activo');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTabs);
  } else {
    inicializarTabs();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
